import React from 'react';

const CV = () => {
    return (
        <main className="py-4 py-md-5" style={{ minHeight: '100vh' }}>
            <div className="container" style={{ maxWidth: '1040px' }}>
                <div className="lg-glass lg-glass--section p-2 p-md-3">
                    <iframe
                        src="/cv.pdf"
                        style={{
                            width: '100%',
                            height: 'min(88vh, 900px)',
                            border: 'none',
                            borderRadius: '12px',
                            display: 'block',
                            background: '#111'
                        }}
                        title="CV PDF"
                    />
                </div>
            </div>
        </main>
    );
};

export default CV;
